import { render, staticRenderFns } from "./LandingPageCreate.vue?vue&type=template&id=9166022c"
import script from "./LandingPageCreate.vue?vue&type=script&lang=ts"
export * from "./LandingPageCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports